(() => {
  const PAGE_PATH = "/apps/loyalty";
  const LIST_SELECTOR = ".appstleLoyaltyPageV2SocialMediaReferralList";
  const INPUT_SELECTOR = ".appstleLoyaltyPageV2InputField";
  const BUTTON_CLASS =
    "appstleLoyaltyPageV2SocialMediaReferralListItem vitamii-referral-share";
  const COPY_STYLE_ID = "vitamii-referral-copy";
  const VISITOR_CLASS = "vitamii-referral-visitor";
  const PAGE_VISITOR_CLASS = "vitamii-referral-page--visitor";
  const INTRO_CLASS = "vitamii-referral-visitor__intro";
  const TUTORIAL_ID = "vitamii-referral-tutorial";
  const DASHBOARD_ID = "vitamii-referral-dashboard";
  const SHARE_PANEL_ID = "vitamii-referral-share-panel";
  const HERO_CTA_SELECTOR = "[data-vitamii-referral-hero-cta]";
  const COPY_STATUS_ID = "vitamii-referral-copy-status";
  const ROUTE_CLASS = "vitamii-referral-route";
  const FRIEND_MODE_CLASS = "vitamii-referral-friend-mode";
  const FRIEND_PARAM = "vitamii_referral_friend";
  const RETURN_SESSION_KEY = "vitamii_referral_return_v1";
  const FRIEND_NOTICE_ID = "vitamii-referral-friend-notice";
  const REWARDS_SECTION_SELECTOR =
    "#appstleLoyaltyPageV2RewardsSection";
  const REWARDS_TITLE_SELECTOR =
    ".appstleLoyaltyPageV2RewardsSectionHeaderTitle";
  const REWARDS_SUBTITLE_SELECTOR =
    ".appstleLoyaltyPageV2RewardsSectionHeaderSubtitle";
  const REWARDS_LIST_SELECTOR =
    ".appstleLoyaltyPageV2RewardsList";
  const REFERRED_SECTION_SELECTOR =
    ".appstleLoyaltyPageV2ReferredSection";
  const REFERRED_ROW_SELECTOR =
    ".appstleLoyaltyPageV2ReferredListTableBody .appstleLoyaltyPageV2ReferredListTableListItem";
  const HISTORY_PANEL_ID = "vitamii-referral-history-panel";
  const HERO_COPY =
    "Nos produits ont soulagé votre loulou ? Faites-en profiter un proche.";
  const INTRO_COPY =
    "Partagez votre expérience uniquement si vous êtes satisfait. Votre proche reçoit 10 € dès 49 €, puis vous recevez 10 € après sa première commande éligible.";

  function track(eventName, details = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      referral_role: "customer",
      ...details,
    });
  }

  function suppressReferralMarketingOverlay() {
    const overlayTextPattern =
      /un petit cadeau vous attend|partage votre canap[eé]/i;

    function findOverlay(element) {
      let candidate = null;
      let current = element;

      while (current && current !== document.body) {
        const style = window.getComputedStyle(current);
        if (style.position === "fixed" || current.getAttribute("role") === "dialog") {
          candidate = current;
        }
        current = current.parentElement;
      }

      return candidate;
    }

    function suppressWithin(root) {
      if (!root) return;
      if (root.nodeType === Node.TEXT_NODE) root = root.parentElement;
      if (!root || root.nodeType !== Node.ELEMENT_NODE) return;

      const elements = [root, ...root.querySelectorAll("*")];
      elements.forEach((element) => {
        if (!overlayTextPattern.test(element.textContent || "")) return;

        const overlay = findOverlay(element);
        if (!overlay) return;

        overlay.setAttribute("data-vrf-suppressed-marketing-overlay", "true");
        overlay.setAttribute("aria-hidden", "true");
        overlay.style.setProperty("display", "none", "important");

        if (document.body.style.overflow === "hidden") {
          document.body.style.removeProperty("overflow");
        }
        if (document.documentElement.style.overflow === "hidden") {
          document.documentElement.style.removeProperty("overflow");
        }
      });
    }

    suppressWithin(document.body);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach(suppressWithin);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function readSession(key) {
    try {
      const value = JSON.parse(window.sessionStorage.getItem(key) || "null");
      if (!value || !value.expiresAt || value.expiresAt <= Date.now()) {
        window.sessionStorage.removeItem(key);
        return null;
      }
      return value;
    } catch (error) {
      return null;
    }
  }

  function removeSession(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      // Le parcours reste utilisable même si le stockage est indisponible.
    }
  }

  const normalizedPath = window.location.pathname.replace(/\/+$/, "");
  const params = new URLSearchParams(window.location.search);
  const isReferralActivation =
    params.get("appstle_referral") === "true" ||
    Boolean(params.get("appstle_referral_code"));
  const returnIntent = readSession(RETURN_SESSION_KEY);
  const onLoyaltyPage = normalizedPath.endsWith(PAGE_PATH);

  if (
    returnIntent?.target &&
    !onLoyaltyPage &&
    !isReferralActivation &&
    (window.location.hostname.endsWith("vitamii.fr") ||
      window.__VITAMII_REFERRAL_QA__ === true)
  ) {
    removeSession(RETURN_SESSION_KEY);
    track("vitamii_referral_friend_return_redirect");
    window.location.replace(returnIntent.target);
    return;
  }

  if (!normalizedPath.endsWith(PAGE_PATH)) return;
  suppressReferralMarketingOverlay();
  const isFriendMode = params.get(FRIEND_PARAM) === "1";
  if (isFriendMode) {
    document.documentElement.classList.add(FRIEND_MODE_CLASS);
    removeSession(RETURN_SESSION_KEY);
    track("vitamii_referral_friend_space_view");
  }
  document.documentElement.classList.add(ROUTE_CLASS);

  const icons = {
    whatsapp: `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M20 11.7a8 8 0 0 1-11.8 7l-4.2 1 1.1-4A8 8 0 1 1 20 11.7Z"/>
        <path d="M9.1 8.1c.2-.4.4-.4.7-.4h.4c.2 0 .4.1.5.5l.7 1.6c.1.3.1.5-.1.7l-.5.6c-.2.2-.1.4 0 .6.7 1.2 1.6 2 2.8 2.6.2.1.4.1.6-.1l.7-.9c.2-.2.4-.3.7-.2l1.7.8c.3.1.5.3.5.5 0 .2-.1 1.3-.8 1.9-.7.7-1.7 1-2.8.7-1.1-.3-2.6-1-4.1-2.3-1.8-1.6-2.8-3.5-3.1-4.5-.3-1 .1-1.7.6-2.1.2-.2.4-.4.5-.5Z"/>
      </svg>`,
    sms: `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M5.2 5.5h13.6A2.2 2.2 0 0 1 21 7.7v7.7a2.2 2.2 0 0 1-2.2 2.2H11l-4.7 2.7.8-2.7H5.2A2.2 2.2 0 0 1 3 15.4V7.7a2.2 2.2 0 0 1 2.2-2.2Z"/>
        <path d="M7.5 11.6h.1M12 11.6h.1M16.5 11.6h.1"/>
      </svg>`,
    email: `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="3" y="5.5" width="18" height="13" rx="2"/>
        <path d="m4.3 7 7.7 6 7.7-6"/>
      </svg>`,
  };

  function makeShareLink({ channel, label, href, newTab = false }) {
    const link = document.createElement("a");
    link.className = BUTTON_CLASS;
    link.href = href;
    link.dataset.vitamiiShare = channel;
    link.setAttribute("aria-label", `Partager par ${label}`);

    if (newTab) {
      link.target = "_blank";
      link.rel = "noopener noreferrer";
    }

    link.innerHTML = `
      <span class="vitamii-referral-share__icon">${icons[channel]}</span>
      <span class="vitamii-referral-share__label">${label}</span>`;

    return link;
  }

  function applyReferralCopy() {
    let style = document.getElementById(COPY_STYLE_ID);
    if (!style) {
      style = document.createElement("style");
      style.id = COPY_STYLE_ID;
      document.head.append(style);
    }

    const criticalStyles = `
      html body .appstleLoyaltyPageV2 .appstleLoyaltyPageV2HeroTitle::before {
        content: "${HERO_COPY}" !important;
      }

      html body .appstleLoyaltyPageV2 .appstleLoyaltyPageV2HeroInformation::after {
        content: none !important;
        display: none !important;
      }
    `;

    if (style.textContent !== criticalStyles) {
      style.textContent = criticalStyles;
    }
  }

  function fallbackCopyText(text) {
    const copyField = document.createElement("textarea");
    copyField.value = text;
    copyField.setAttribute("readonly", "");
    copyField.style.position = "fixed";
    copyField.style.inset = "-9999px auto auto -9999px";
    document.body.append(copyField);
    copyField.select();
    document.execCommand("copy");
    copyField.remove();
  }

  function copyText(text) {
    if (navigator.clipboard?.writeText && window.isSecureContext) {
      navigator.clipboard.writeText(text).catch(() => fallbackCopyText(text));
      return;
    }

    fallbackCopyText(text);
  }

  function discountUrl(code) {
    return (
      `/discount/${encodeURIComponent(code)}` +
      `?redirect=${encodeURIComponent("/collections/all")}`
    );
  }

  function normalizeRewardCode(value) {
    const candidate = String(value || "")
      .trim()
      .replace(/^["']|["']$/g, "");
    const excluded = new Set([
      "RECOMPENSE",
      "RECOMPENSES",
      "DISPONIBLE",
      "DISPONIBLES",
      "UTILISER",
      "COPIER",
      "VITAMII",
      "PARRAINAGE",
      "PROMOTION",
    ]);

    if (!/^[A-Za-z0-9][A-Za-z0-9_-]{4,39}$/.test(candidate)) return "";
    if (excluded.has(candidate.toUpperCase())) return "";
    return candidate;
  }

  function findRewardCode(item) {
    const explicitNodes = item.querySelectorAll(
      "[data-discount-code], [data-code], code, input[readonly], input[value]",
    );

    for (const node of explicitNodes) {
      const explicitValue =
        node.dataset?.discountCode ||
        node.dataset?.code ||
        ("value" in node ? node.value : node.textContent);
      const normalized = normalizeRewardCode(explicitValue);
      if (normalized) return normalized;
    }

    const text = normalizedText(item);
    const labelledMatch = text.match(
      /(?:code(?:\s+promo)?|récompense)\s*:?\s*([A-Za-z0-9][A-Za-z0-9_-]{4,39})/i,
    );
    return normalizeRewardCode(labelledMatch?.[1]);
  }

  function ensureRewardApplyLinks(list) {
    if (!list) return [];

    const codes = [];
    [...list.children].forEach((item) => {
      const code = findRewardCode(item);
      if (!code) return;
      codes.push(code);

      let action = item.querySelector("[data-vitamii-reward-apply]");
      if (!action) {
        action = document.createElement("a");
        action.className = "vitamii-referral-reward-apply";
        action.dataset.vitamiiRewardApply = "";
        action.addEventListener("click", () => {
          track("vitamii_referral_reward_apply", {
            referral_context: isFriendMode ? "friend" : "referrer",
          });
        });
        item.append(action);
      }

      action.href = discountUrl(code);
      action.textContent = "Appliquer ce code à mon panier";
      action.setAttribute(
        "aria-label",
        "Appliquer cette récompense à mon panier",
      );
    });

    return [...new Set(codes)];
  }

  function enhanceNativeControls() {
    const title = document.querySelector(".appstleLoyaltyPageV2HeroTitle");
    if (title) {
      if (title.getAttribute("role") !== "heading") {
        title.setAttribute("role", "heading");
      }
      if (title.getAttribute("aria-level") !== "1") {
        title.setAttribute("aria-level", "1");
      }
      if (title.getAttribute("aria-label") !== HERO_COPY) {
        title.setAttribute("aria-label", HERO_COPY);
      }
    }

    const input = document.querySelector(INPUT_SELECTOR);
    if (input) {
      if (
        input.getAttribute("aria-label") !==
        "Votre lien de parrainage personnel"
      ) {
        input.setAttribute(
          "aria-label",
          "Votre lien de parrainage personnel",
        );
      }
      if (input.getAttribute("autocomplete") !== "off") {
        input.setAttribute("autocomplete", "off");
      }
      if (input.getAttribute("spellcheck") !== "false") {
        input.setAttribute("spellcheck", "false");
      }
    }

    const copyContainer = document.querySelector(
      ".appstleLoyaltyPageV2ReferralsLinkField",
    );
    if (!copyContainer) return;

    const feedbackActive =
      copyContainer.dataset.vitamiiCopyFeedbackActive === "true";

    copyContainer.setAttribute("role", "button");
    copyContainer.setAttribute("tabindex", "0");
    copyContainer.setAttribute(
      "aria-label",
      feedbackActive ? "Lien copié" : "Copier mon lien de parrainage",
    );

    if (copyContainer.dataset.vitamiiCopyEnhanced === "true") return;
    copyContainer.dataset.vitamiiCopyEnhanced = "true";

    copyContainer.addEventListener("click", () => {
      const referralInput = document.querySelector(INPUT_SELECTOR);
      const referralLink = referralInput?.value?.trim();

      if (!referralLink) return;

      copyText(referralLink);
      window.clearTimeout(copyContainer.vitamiiCopyTimer);
      copyContainer.dataset.vitamiiCopyFeedbackActive = "true";
      copyContainer.setAttribute("aria-label", "Lien copié");
      const copyStatus = document.getElementById(COPY_STATUS_ID);
      if (copyStatus) {
        copyStatus.textContent = "";
        window.requestAnimationFrame(() => {
          copyStatus.textContent = "Lien copié";
        });
      }

      copyContainer.vitamiiCopyTimer = window.setTimeout(() => {
        copyContainer.dataset.vitamiiCopyFeedbackActive = "";
        copyContainer.setAttribute(
          "aria-label",
          "Copier mon lien de parrainage",
        );
        if (copyStatus) copyStatus.textContent = "";
      }, 2400);
    }, true);

    copyContainer.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault();
      copyContainer.click();
    });
  }

  function enhanceRewardsSection() {
    const section = document.querySelector(REWARDS_SECTION_SELECTOR);
    if (!section) return;

    const title = section.querySelector(REWARDS_TITLE_SELECTOR);
    const subtitle = section.querySelector(REWARDS_SUBTITLE_SELECTOR);
    const list = section.querySelector(REWARDS_LIST_SELECTOR);
    const rewardCount = list?.children.length || 0;
    ensureRewardApplyLinks(list);

    if (title) {
      title.id = "vitamii-referral-rewards-title";
      title.setAttribute("role", "heading");
      title.setAttribute("aria-level", "2");
      if (title.textContent.trim() !== "Mes récompenses") {
        title.textContent = "Mes récompenses";
      }
    }

    section.setAttribute("aria-labelledby", "vitamii-referral-rewards-title");
    section.dataset.vitamiiRewardCount = String(rewardCount);
    section.dataset.vitamiiEmptyRewards = String(rewardCount === 0);

    if (!subtitle) return;

    const expectedSubtitle =
      rewardCount === 0
        ? isFriendMode
          ? "Votre invitation est enregistrée. Votre code de 10 € apparaîtra ici dès qu’Appstle aura terminé de le créer."
          : "Aucune récompense pour le moment. Votre code de 10 € apparaîtra ici après la première commande éligible de votre proche."
        : `Vous avez ${rewardCount} ${
            rewardCount > 1 ? "récompenses disponibles" : "récompense disponible"
          }.`;

    if (subtitle.textContent.trim() !== expectedSubtitle) {
      subtitle.textContent = expectedSubtitle;
    }
  }

  function normalizedText(element) {
    return element?.textContent?.replace(/\s+/g, " ").trim() || "";
  }

  function findNativeReferredSection() {
    const sections = [...document.querySelectorAll(REFERRED_SECTION_SELECTOR)];

    return (
      sections.sort(
        (left, right) =>
          right.querySelectorAll(REFERRED_ROW_SELECTOR).length -
          left.querySelectorAll(REFERRED_ROW_SELECTOR).length,
      )[0] || null
    );
  }

  function enhanceReferredSection() {
    const section = findNativeReferredSection();
    if (!section) return;

    const title = section.querySelector(
      ".appstleLoyaltyPageV2ReferredSectionTitle",
    );
    const table = document.querySelector(
      ".appstleLoyaltyPageV2ReferredListTable",
    );
    const paginationLabel = document.querySelector(
      ".appstleLoyaltyPageV2ReferredListContainer .pagination-label",
    );
    const previousButton = document.querySelector(
      ".appstleLoyaltyPageV2ReferredListContainer .pagination-previous-button",
    );
    const nextButton = document.querySelector(
      ".appstleLoyaltyPageV2ReferredListContainer .pagination-next-button",
    );
    const rowCount =
      section.querySelectorAll(REFERRED_ROW_SELECTOR).length || 0;

    if (title) {
      title.id = "vitamii-referral-history-title";
      title.setAttribute("role", "heading");
      title.setAttribute("aria-level", "3");
      section.setAttribute(
        "aria-labelledby",
        "vitamii-referral-history-title",
      );
    }

    if (table) {
      table.setAttribute(
        "aria-label",
        "Invitations de parrainage et leur statut",
      );
    }

    previousButton?.setAttribute("aria-label", "Page précédente");
    nextButton?.setAttribute("aria-label", "Page suivante");

    if (!paginationLabel) return;

    const nativeCopy = normalizedText(paginationLabel);
    const totalMatch = nativeCopy.match(/\bof\s+(\d+)\s+entries\b/i);
    const total = totalMatch ? Number(totalMatch[1]) : rowCount;
    const expectedCopy = `${total} ${
      total > 1 ? "invitations affichées" : "invitation affichée"
    }`;

    if (paginationLabel.textContent.trim() !== expectedCopy) {
      paginationLabel.textContent = expectedCopy;
    }
  }

  function ensureReferralHistoryPanel(dashboard) {
    if (!dashboard) return null;

    const container = dashboard.querySelector(
      ".vitamii-referral-dashboard__container",
    );
    const grid = dashboard.querySelector(
      ".vitamii-referral-dashboard__grid",
    );
    const nativeSection = findNativeReferredSection();

    if (!container || !grid) return null;

    let panel = document.getElementById(HISTORY_PANEL_ID);
    if (!panel) {
      panel = document.createElement("section");
      panel.id = HISTORY_PANEL_ID;
      panel.className = "vitamii-referral-dashboard__history";
      panel.setAttribute(
        "aria-labelledby",
        "vitamii-referral-history-panel-title",
      );
      panel.innerHTML = `
        <header class="vitamii-referral-dashboard__history-header">
          <div>
            <h3 id="vitamii-referral-history-panel-title">Mes parrainages</h3>
            <p>
              Suivez ici les invitations envoyées et leur statut de validation.
            </p>
          </div>
          <span data-vitamii-history-badge></span>
        </header>
        <div
          class="vitamii-referral-dashboard__history-table"
          role="table"
          aria-label="Invitations de parrainage et leur statut"
        >
          <div class="vitamii-referral-dashboard__history-table-head" role="row">
            <span role="columnheader">E-mail</span>
            <span role="columnheader">Statut</span>
            <span role="columnheader" data-vitamii-history-note-head>Note</span>
          </div>
          <div data-vitamii-history-rows role="rowgroup"></div>
          <footer class="vitamii-referral-dashboard__history-pagination">
            <span data-vitamii-history-pagination></span>
            <span class="vitamii-referral-dashboard__history-pagination-actions">
              <button
                type="button"
                aria-label="Page précédente"
                data-vitamii-history-previous
              >‹</button>
              <button
                type="button"
                aria-label="Page suivante"
                data-vitamii-history-next
              >›</button>
            </span>
          </footer>
        </div>
      `;
      grid.insertAdjacentElement("afterend", panel);

      panel
        .querySelector("[data-vitamii-history-previous]")
        ?.addEventListener("click", () => {
          findNativeReferredSection()
            ?.querySelector(".pagination-previous-button")
            ?.click();
        });
      panel
        .querySelector("[data-vitamii-history-next]")
        ?.addEventListener("click", () => {
          findNativeReferredSection()
            ?.querySelector(".pagination-next-button")
            ?.click();
        });
    }

    if (panel.previousElementSibling !== grid) {
      grid.insertAdjacentElement("afterend", panel);
    }

    const nativeRows = nativeSection
      ? [...nativeSection.querySelectorAll(REFERRED_ROW_SELECTOR)]
      : [];
    const rowCount = nativeRows.length;
    const hasHistory = !isFriendMode && rowCount > 0;

    panel.hidden = !hasHistory;
    panel.setAttribute("aria-hidden", String(!hasHistory));
    panel.dataset.vitamiiReferralCount = String(rowCount);
    dashboard.classList.toggle(
      "vitamii-referral-dashboard--has-history",
      hasHistory,
    );

    if (!hasHistory || !nativeSection) return panel;

    const entries = nativeRows.map((row) => {
      const cells = [
        ...row.querySelectorAll(".appstleLoyaltyPageV2ReferredListItem"),
      ];

      return {
        email: normalizedText(cells[0]),
        status: normalizedText(cells[1]),
        note: normalizedText(cells[2]),
      };
    });
    const badgeCopy =
      normalizedText(
        nativeSection.querySelector(
          ".appstleLoyaltyPageV2TotalReferredBadge",
        ),
      ) || "0 parrainages complétés";
    const paginationCopy =
      normalizedText(nativeSection.querySelector(".pagination-label")) ||
      `${rowCount} ${
        rowCount > 1 ? "invitations affichées" : "invitation affichée"
      }`;
    const nativePrevious = nativeSection.querySelector(
      ".pagination-previous-button",
    );
    const nativeNext = nativeSection.querySelector(
      ".pagination-next-button",
    );
    const previousDisabled =
      !nativePrevious ||
      nativePrevious.disabled ||
      nativePrevious.getAttribute("aria-disabled") === "true";
    const nextDisabled =
      !nativeNext ||
      nativeNext.disabled ||
      nativeNext.getAttribute("aria-disabled") === "true";
    const hasNote = entries.some((entry) => entry.note);
    const signature = JSON.stringify({
      entries,
      badgeCopy,
      paginationCopy,
      previousDisabled,
      nextDisabled,
      hasNote,
    });

    if (panel.dataset.vitamiiHistorySignature === signature) return panel;

    panel.dataset.vitamiiHistorySignature = signature;
    panel.classList.toggle(
      "vitamii-referral-dashboard__history--with-note",
      hasNote,
    );

    const badge = panel.querySelector("[data-vitamii-history-badge]");
    const rowsSlot = panel.querySelector("[data-vitamii-history-rows]");
    const pagination = panel.querySelector(
      "[data-vitamii-history-pagination]",
    );
    const previous = panel.querySelector("[data-vitamii-history-previous]");
    const next = panel.querySelector("[data-vitamii-history-next]");

    if (badge) badge.textContent = badgeCopy;
    if (pagination) pagination.textContent = paginationCopy;
    if (previous) previous.disabled = previousDisabled;
    if (next) next.disabled = nextDisabled;

    if (rowsSlot) {
      const fragment = document.createDocumentFragment();

      entries.forEach((entry) => {
        const row = document.createElement("div");
        row.className = "vitamii-referral-dashboard__history-row";
        row.setAttribute("role", "row");

        [
          ["E-mail", entry.email, "email"],
          ["Statut", entry.status, "status"],
          ["Note", entry.note, "note"],
        ].forEach(([label, value, type]) => {
          const cell = document.createElement("span");
          cell.className = `vitamii-referral-dashboard__history-cell vitamii-referral-dashboard__history-cell--${type}`;
          cell.dataset.label = label;
          cell.setAttribute("role", "cell");

          if (type === "status") {
            const status = document.createElement("span");
            status.className =
              "vitamii-referral-dashboard__history-status-value";
            status.textContent = value;
            cell.append(status);
          } else {
            cell.textContent = value;
          }

          row.append(cell);
        });

        fragment.append(row);
      });

      rowsSlot.replaceChildren(fragment);
    }

    return panel;
  }

  function normalizeKnownPageCopy() {
    const copyright = [
      ...document.querySelectorAll("footer.vmf .ft-bottom *"),
    ].find(
      (element) =>
        element.childElementCount === 0 &&
        normalizedText(element).startsWith("© Vitamii 2026") &&
        normalizedText(element).endsWith("Tous droits réservés"),
    );

    if (copyright) {
      copyright.textContent = "© Vitamii 2026. Tous droits réservés";
    }
  }

  function updateReferralDashboard(dashboard) {
    if (!dashboard) return;

    const list = document.querySelector(REWARDS_LIST_SELECTOR);
    const rewardCount = list?.children.length || 0;
    const rewardCodes = ensureRewardApplyLinks(list);
    const amount = rewardCount * 10;
    const amountElement = dashboard.querySelector(
      "[data-vitamii-wallet-amount]",
    );
    const amountLabel = dashboard.querySelector(
      ".vitamii-referral-dashboard__wallet-amount span",
    );
    const walletTitle = dashboard.querySelector(
      "#vitamii-referral-wallet-title",
    );
    const walletEyebrow = dashboard.querySelector(
      ".vitamii-referral-dashboard__wallet .vitamii-referral-dashboard__eyebrow",
    );
    const shareTitle = dashboard.querySelector(
      "#vitamii-referral-share-title",
    );
    const shareEyebrow = dashboard.querySelector(
      ".vitamii-referral-dashboard__share .vitamii-referral-dashboard__eyebrow",
    );
    const shareCopy = dashboard.querySelector(
      ".vitamii-referral-dashboard__share .vitamii-referral-dashboard__panel-copy",
    );
    const copyElement = dashboard.querySelector(
      "[data-vitamii-wallet-copy]",
    );
    const nativeSocialLabel = dashboard.querySelector(
      ".appstleLoyaltyPageV2SocialMediaReferralLabel",
    );
    const walletAction = dashboard.querySelector(
      "[data-vitamii-wallet-action]",
    );
    const dashboardDescription = dashboard.querySelector(
      ".vitamii-referral-dashboard__header > p:last-child",
    );

    dashboard.dataset.vitamiiRewardCount = String(rewardCount);
    dashboard.classList.toggle(
      "vitamii-referral-dashboard--friend",
      isFriendMode,
    );

    if (dashboardDescription) {
      dashboardDescription.textContent = isFriendMode
        ? "Retrouvez votre code de 10 €. Les autres offres et réductions s’appliquent d’abord : le panier doit alors atteindre 49 €, puis vos 10 € sont déduits."
        : "Gérez votre lien, suivez vos parrainages et retrouvez vos récompenses.";
    }

    if (walletEyebrow) {
      walletEyebrow.textContent = isFriendMode
        ? "Votre offre de bienvenue"
        : "Vos récompenses";
    }

    if (walletTitle) {
      walletTitle.textContent = isFriendMode
        ? "Mon code de 10 €"
        : "Ma cagnotte";
    }

    if (shareEyebrow) {
      shareEyebrow.textContent = isFriendMode
        ? "Parrainer à votre tour"
        : "Prêt à partager";
    }

    if (shareTitle) {
      shareTitle.textContent = isFriendMode
        ? "Votre propre lien est aussi disponible"
        : "Votre lien personnel est prêt";
    }

    if (shareCopy) {
      shareCopy.textContent = isFriendMode
        ? "Une fois votre expérience faite, vous pourrez partager ce lien avec un proche si vous êtes satisfait."
        : "Ce lien est unique. Envoyez-le uniquement aux proches de votre choix.";
    }

    if (amountElement) {
      const expectedAmount =
        isFriendMode && rewardCount === 0
          ? "En cours"
          : `${new Intl.NumberFormat("fr-FR").format(amount)} €`;
      if (amountElement.textContent.trim() !== expectedAmount) {
        amountElement.textContent = expectedAmount;
      }
    }

    if (amountLabel) {
      const expectedLabel =
        isFriendMode && rewardCount === 0 ? "de création" : "disponible";
      if (amountLabel.textContent.trim() !== expectedLabel) {
        amountLabel.textContent = expectedLabel;
      }
    }

    if (copyElement) {
      const expectedCopy =
        rewardCount === 0
          ? isFriendMode
            ? "Votre invitation est bien enregistrée. Le code peut prendre quelques instants à apparaître. Vérifiez que vous êtes connecté avec la même adresse e-mail."
            : "Aucune récompense pour le moment. Vos 10 € apparaîtront ici après la première commande éligible de votre proche."
          : `Vous avez ${rewardCount} ${
              rewardCount > 1
                ? "récompenses disponibles"
                : "récompense disponible"
            }. Retrouvez vos codes ci-dessous et utilisez-les au paiement.`;
      if (copyElement.textContent.trim() !== expectedCopy) {
        copyElement.textContent = expectedCopy;
      }
    }

    if (
      nativeSocialLabel &&
      nativeSocialLabel.textContent.trim() !== "Partager directement"
    ) {
      nativeSocialLabel.textContent = "Partager directement";
    }

    if (walletAction) {
      const hasRewards = rewardCount > 0;
      const hasDetectedCode = rewardCodes.length > 0;
      const expectedLabel = hasDetectedCode
        ? "Appliquer mes 10 €"
        : hasRewards
          ? "Voir mon code"
          : isFriendMode
            ? "Actualiser mon code"
            : "Comment gagner 10 € ?";
      const expectedHref = hasDetectedCode
        ? discountUrl(rewardCodes[0])
        : hasRewards
          ? `#${REWARDS_SECTION_SELECTOR.slice(1)}`
          : isFriendMode
            ? `#${DASHBOARD_ID}`
            : `#${TUTORIAL_ID}`;

      if (walletAction.textContent.trim() !== expectedLabel) {
        walletAction.textContent = expectedLabel;
      }
      if (walletAction.getAttribute("href") !== expectedHref) {
        walletAction.setAttribute("href", expectedHref);
      }
      walletAction.dataset.vitamiiRefresh =
        isFriendMode && !hasRewards ? "true" : "false";
    }
  }

  function ensureFriendNotice(dashboard) {
    if (!dashboard || !isFriendMode) return null;

    let notice = document.getElementById(FRIEND_NOTICE_ID);
    if (notice) return notice;

    const header = dashboard.querySelector(".vitamii-referral-dashboard__header");
    if (!header) return null;

    notice = document.createElement("section");
    notice.id = FRIEND_NOTICE_ID;
    notice.className = "vitamii-referral-friend-notice";
    notice.setAttribute(
      "aria-labelledby",
      "vitamii-referral-friend-notice-title",
    );
    notice.innerHTML = `
      <span class="vitamii-referral-friend-notice__check" aria-hidden="true">✓</span>
      <div>
        <p class="vitamii-referral-dashboard__eyebrow">Votre invitation</p>
        <h3 id="vitamii-referral-friend-notice-title">
          Vous êtes au bon endroit pour récupérer vos 10 €
        </h3>
        <p>
          Votre invitation est enregistrée. Votre code apparaît dans le bloc
          «&nbsp;Mon code de 10&nbsp;€&nbsp;» ci-dessous. Utilisez bien la même
          adresse e-mail que lors de l’activation.
        </p>
        <div class="vitamii-referral-friend-notice__actions">
          <a href="#vitamii-referral-wallet-title">Voir mon code</a>
          <a href="mailto:contact@vitamii.fr?subject=Aide%20code%20de%20parrainage">
            Mon code n’apparaît pas
          </a>
        </div>
      </div>
    `;
    header.insertAdjacentElement("afterend", notice);

    notice
      .querySelector('a[href="#vitamii-referral-wallet-title"]')
      ?.addEventListener("click", () => {
        track("vitamii_referral_friend_wallet_open");
      });
    return notice;
  }

  function ensureReferralDashboard() {
    const page = document.querySelector(".appstleLoyaltyPageV2");
    const referralSection = document.querySelector(
      "#appstleLoyaltyPageV2ReferralSection",
    );
    const rewardsSection = document.querySelector(REWARDS_SECTION_SELECTOR);
    const tutorial = document.getElementById(TUTORIAL_ID);

    if (!page || !referralSection || !rewardsSection || !tutorial) return null;

    let dashboard = document.getElementById(DASHBOARD_ID);
    if (!dashboard) {
      dashboard = document.createElement("section");
      dashboard.id = DASHBOARD_ID;
      dashboard.className = "vitamii-referral-dashboard";
      dashboard.setAttribute(
        "aria-labelledby",
        "vitamii-referral-dashboard-title",
      );
      dashboard.innerHTML = `
        <div class="vitamii-referral-dashboard__container">
          <header class="vitamii-referral-dashboard__header">
            <p class="vitamii-referral-dashboard__eyebrow">Votre compte Vitamii</p>
            <h2 id="vitamii-referral-dashboard-title">Mon espace parrainage</h2>
            <p>
              Gérez votre lien, suivez vos parrainages et retrouvez vos
              récompenses.
            </p>
          </header>

          <ol
            class="vitamii-referral-dashboard__flow"
            aria-label="Les trois étapes du parrainage"
          >
            <li class="vitamii-referral-dashboard__flow-step">
              <span
                class="vitamii-referral-dashboard__flow-badge"
                aria-hidden="true"
              >
                01
              </span>
              <span class="vitamii-referral-dashboard__flow-copy">
                <small>Vous</small>
                <strong>Partagez votre lien</strong>
              </span>
            </li>
            <li class="vitamii-referral-dashboard__flow-step">
              <span
                class="vitamii-referral-dashboard__flow-badge"
                aria-hidden="true"
              >
                10 €
              </span>
              <span class="vitamii-referral-dashboard__flow-copy">
                <small>Votre proche</small>
                <strong>Profite de 10 €</strong>
              </span>
            </li>
            <li class="vitamii-referral-dashboard__flow-step">
              <span
                class="vitamii-referral-dashboard__flow-badge"
                aria-hidden="true"
              >
                10 €
              </span>
              <span class="vitamii-referral-dashboard__flow-copy">
                <small>Après validation</small>
                <strong>Vos 10 € se débloquent</strong>
              </span>
            </li>
          </ol>
          <p class="vitamii-referral-dashboard__flow-condition">
            Vos 10&nbsp;€ se débloquent après validation de la première
            commande de votre proche. Ses autres offres et réductions
            s’appliquent d’abord&nbsp;: son panier doit alors atteindre
            49&nbsp;€, puis ses 10&nbsp;€ de parrainage sont déduits.
          </p>

          <div class="vitamii-referral-dashboard__grid">
            <section
              id="${SHARE_PANEL_ID}"
              class="vitamii-referral-dashboard__share"
              aria-labelledby="vitamii-referral-share-title"
              tabindex="-1"
            >
              <p class="vitamii-referral-dashboard__eyebrow">Prêt à partager</p>
              <h3 id="vitamii-referral-share-title">
                Votre lien personnel est prêt
              </h3>
              <p class="vitamii-referral-dashboard__panel-copy">
                Ce lien est unique. Envoyez-le uniquement aux proches de votre
                choix.
              </p>
              <span
                id="${COPY_STATUS_ID}"
                class="vitamii-referral-visually-hidden"
                role="status"
                aria-live="polite"
              ></span>
              <div data-vitamii-referral-slot></div>
            </section>

            <aside
              class="vitamii-referral-dashboard__wallet"
              aria-labelledby="vitamii-referral-wallet-title"
            >
              <div>
                <p class="vitamii-referral-dashboard__eyebrow">
                  Vos récompenses
                </p>
                <h3 id="vitamii-referral-wallet-title">Ma cagnotte</h3>
                <p class="vitamii-referral-dashboard__wallet-amount">
                  <strong data-vitamii-wallet-amount>0 €</strong>
                  <span>disponible</span>
                </p>
                <p
                  class="vitamii-referral-dashboard__panel-copy"
                  data-vitamii-wallet-copy
                  aria-live="polite"
                >
                  Aucune récompense pour le moment. Vos 10 € apparaîtront ici
                  après la première commande éligible de votre proche.
                </p>
                <div data-vitamii-rewards-slot></div>
              </div>
              <div class="vitamii-referral-dashboard__wallet-footer">
                <a href="#vitamii-referral-tutorial" data-vitamii-wallet-action>
                  Comment gagner 10 € ?
                </a>
              </div>
            </aside>
          </div>
        </div>
      `;

      tutorial.insertAdjacentElement("beforebegin", dashboard);
    }

    const referralSlot = dashboard.querySelector(
      "[data-vitamii-referral-slot]",
    );
    const rewardsSlot = dashboard.querySelector("[data-vitamii-rewards-slot]");

    if (referralSlot && referralSection.parentElement !== referralSlot) {
      referralSlot.append(referralSection);
    }

    if (rewardsSlot && rewardsSection.parentElement !== rewardsSlot) {
      rewardsSlot.append(rewardsSection);
    }

    rewardsSection.removeAttribute("aria-labelledby");
    ensureFriendNotice(dashboard);
    ensureReferralHistoryPanel(dashboard);

    const walletAction = dashboard.querySelector(
      "[data-vitamii-wallet-action]",
    );
    if (
      walletAction &&
      walletAction.dataset.vitamiiActionEnhanced !== "true"
    ) {
      walletAction.dataset.vitamiiActionEnhanced = "true";
      walletAction.addEventListener("click", (event) => {
        if (walletAction.dataset.vitamiiRefresh === "true") {
          event.preventDefault();
          track("vitamii_referral_friend_code_refresh");
          window.location.reload();
          return;
        }

        track("vitamii_referral_wallet_action", {
          referral_context: isFriendMode ? "friend" : "referrer",
        });
      });
    }

    updateReferralDashboard(dashboard);
    return dashboard;
  }

  function findAction(hero, label) {
    const directAction = [...hero.querySelectorAll("a, button, [role='button']")]
      .find((element) => normalizedText(element) === label);

    if (directAction) return directAction;

    const labelElement = [...hero.querySelectorAll("span, p, div")]
      .find((element) => normalizedText(element) === label);

    return labelElement?.closest("a, button, [role='button']") || labelElement;
  }

  function ensureTutorial() {
    const page = document.querySelector(".appstleLoyaltyPageV2");
    const howItWorks = document.querySelector(
      ".appstleLoyaltyPageV2HowItWorks",
    );
    if (!page || !howItWorks) return null;

    let tutorial = document.getElementById(TUTORIAL_ID);
    if (tutorial) return tutorial;

    tutorial = document.createElement("section");
    tutorial.id = TUTORIAL_ID;
    tutorial.className = "vitamii-referral-tutorial";
    tutorial.setAttribute("aria-labelledby", "vitamii-referral-tutorial-title");
    tutorial.innerHTML = `
      <div class="vitamii-referral-tutorial__container">
        <header class="vitamii-referral-tutorial__header">
          <p class="vitamii-referral-tutorial__eyebrow">Comment ça marche</p>
          <h2 id="vitamii-referral-tutorial-title">
            Quatre étapes, tout simplement
          </h2>
          <p class="vitamii-referral-tutorial__lead">
            Vous partagez votre lien. Votre proche active son invitation avec
            son adresse e-mail, puis récupère son code dans son espace
            parrainage.
          </p>
        </header>

        <ol class="vitamii-referral-tutorial__steps">
          <li class="vitamii-referral-tutorial__step">
            <span
              class="vitamii-referral-tutorial__number"
              aria-label="Étape 1 sur 4"
            >Étape 1</span>
            <div>
              <h3>Partagez votre lien</h3>
              <p>
                Copiez votre lien personnel ou envoyez-le directement par
                WhatsApp, SMS ou e-mail.
              </p>
            </div>
          </li>
          <li class="vitamii-referral-tutorial__step">
            <span
              class="vitamii-referral-tutorial__number"
              aria-label="Étape 2 sur 4"
            >Étape 2</span>
            <div>
              <h3>Votre proche active ses 10 €</h3>
              <p>
                Il ouvre votre lien et renseigne l’adresse e-mail qu’il
                utilisera ensuite pour se connecter à Vitamii.
              </p>
            </div>
          </li>
          <li class="vitamii-referral-tutorial__step">
            <span
              class="vitamii-referral-tutorial__number"
              aria-label="Étape 3 sur 4"
            >Étape 3</span>
            <div>
              <h3>Il récupère et utilise son code</h3>
              <p>
                Après connexion avec la même adresse, il ouvre « Mon espace
                parrainage » et applique son code à sa première commande. Ses
                autres offres et réductions s’appliquent d’abord. Son panier
                doit alors atteindre 49 €, puis ses 10 € sont déduits.
              </p>
            </div>
          </li>
          <li class="vitamii-referral-tutorial__step">
            <span
              class="vitamii-referral-tutorial__number"
              aria-label="Étape 4 sur 4"
            >Étape 4</span>
            <div>
              <h3>Utilisez votre récompense</h3>
              <p>
                Après validation de sa commande, votre code de 10 € apparaît
                dans <strong>Ma cagnotte</strong>. Copiez-le et utilisez-le au
                paiement de votre prochaine commande. Vos autres offres et
                réductions s’appliquent d’abord. Votre panier doit alors
                atteindre 49 €, puis vos 10 € sont déduits.
              </p>
            </div>
          </li>
        </ol>

        <section
          class="vitamii-referral-tutorial__conditions"
          aria-labelledby="vitamii-referral-conditions-title"
        >
          <div class="vitamii-referral-tutorial__conditions-heading">
            <span aria-hidden="true">✓</span>
            <div>
              <p class="vitamii-referral-tutorial__eyebrow">À retenir</p>
              <h3 id="vitamii-referral-conditions-title">
                Les conditions, en bref
              </h3>
            </div>
          </div>
          <ul>
            <li>Votre proche ne doit encore jamais avoir commandé chez Vitamii.</li>
            <li>Les offres et réductions disponibles s’appliquent d’abord.</li>
            <li>Le panier doit alors atteindre 49 € minimum, puis les 10 € de parrainage sont déduits.</li>
          </ul>
        </section>

        <div class="vitamii-referral-tutorial__actions">
          <a
            href="#vitamii-referral-dashboard"
            class="vitamii-referral-tutorial__cta"
            data-vitamii-tutorial-cta
          >
            Accéder à mon espace parrainage
          </a>
          <p>
            Un lien qui ne s’affiche pas ?
            <a href="mailto:contact@vitamii.fr">Écrivez-nous à contact@vitamii.fr</a>.
          </p>
        </div>
      </div>
    `;

    howItWorks.insertAdjacentElement("afterend", tutorial);
    return tutorial;
  }

  function applyVisitorState() {
    const page = document.querySelector(".appstleLoyaltyPageV2");
    const hero = document.querySelector(".appstleLoyaltyPageV2HeroInformation");
    const title = hero?.querySelector(".appstleLoyaltyPageV2HeroTitle");
    if (!hero || !title) return;

    const loginAction = findAction(hero, "Se connecter");
    const joinAction =
      findAction(hero, "Rejoindre maintenant") ||
      findAction(hero, "Créer un compte");
    const isVisitor = Boolean(loginAction || joinAction);

    hero.classList.toggle(VISITOR_CLASS, isVisitor);
    page?.classList.toggle(PAGE_VISITOR_CLASS, isVisitor);

    let intro = hero.querySelector(`.${INTRO_CLASS}`);
    if (!intro) {
      intro = document.createElement("p");
      intro.className = INTRO_CLASS;
      title.insertAdjacentElement("afterend", intro);
    }
    if (intro.textContent !== INTRO_COPY) {
      intro.textContent = INTRO_COPY;
    }

    let heroCta = hero.querySelector(HERO_CTA_SELECTOR);
    if (isVisitor) {
      heroCta?.remove();
    } else if (!heroCta) {
      heroCta = document.createElement("a");
      heroCta.className = "vitamii-referral-hero__cta";
      heroCta.href = `#${SHARE_PANEL_ID}`;
      heroCta.dataset.vitamiiReferralHeroCta = "true";
      heroCta.innerHTML = `
        <span>Voir mon lien personnel</span>
        <svg viewBox="0 0 20 20" aria-hidden="true">
          <path d="M10 3v12M5.5 10.5 10 15l4.5-4.5"/>
        </svg>
      `;
      intro.insertAdjacentElement("afterend", heroCta);
      heroCta.addEventListener("click", (event) => {
        const target = document.getElementById(SHARE_PANEL_ID);
        if (!target) return;

        event.preventDefault();
        const reducedMotion = window.matchMedia(
          "(prefers-reduced-motion: reduce)",
        ).matches;
        track("vitamii_referral_hero_cta_click");
        target.scrollIntoView({
          behavior: reducedMotion ? "auto" : "smooth",
          block: "start",
        });
        window.setTimeout(
          () => target.focus({ preventScroll: true }),
          reducedMotion ? 0 : 450,
        );
      });
    }

    [...hero.querySelectorAll("p, span, div")].forEach((element) => {
      const text = normalizedText(element);
      const isNativeSubheading =
        text.startsWith("Faites-vous d’abord votre avis. Satisfait de Vitamii") &&
        text.length < 320 &&
        !element.querySelector("a, button, [role='button']") &&
        !element.classList.contains(INTRO_CLASS);

      if (
        isNativeSubheading &&
        element.dataset.vitamiiNativeSubheading !== "true"
      ) {
        element.dataset.vitamiiNativeSubheading = "true";
      }
    });

    if (loginAction?.dataset && loginAction.dataset.vitamiiAuthAction !== "login") {
      loginAction.dataset.vitamiiAuthAction = "login";
    }
    if (joinAction?.dataset && joinAction.dataset.vitamiiAuthAction !== "join") {
      joinAction.dataset.vitamiiAuthAction = "join";
    }
    if (joinAction && normalizedText(joinAction) !== "Créer un compte") {
      joinAction.textContent = "Créer un compte";
    }

    const tutorial = ensureTutorial();
    const tutorialCta = tutorial?.querySelector("[data-vitamii-tutorial-cta]");

    if (!tutorialCta) return;

    const expectedLabel = isVisitor
      ? "Se connecter pour obtenir mon lien"
      : "Accéder à mon espace parrainage";
    if (tutorialCta.textContent.trim() !== expectedLabel) {
      tutorialCta.textContent = expectedLabel;
    }

    if (tutorialCta.dataset.vitamiiTutorialReady === "true") return;
    tutorialCta.dataset.vitamiiTutorialReady = "true";
    tutorialCta.addEventListener("click", (event) => {
      const currentHero = document.querySelector(
        ".appstleLoyaltyPageV2HeroInformation",
      );
      const currentLogin = currentHero
        ? findAction(currentHero, "Se connecter")
        : null;
      const currentJoin = currentHero
        ? findAction(currentHero, "Rejoindre maintenant") ||
          findAction(currentHero, "Créer un compte")
        : null;

      if (currentLogin || currentJoin) {
        event.preventDefault();
        (currentLogin || currentJoin).click();
      }
    });
  }

  function enhanceReferralPage() {
    const list = document.querySelector(LIST_SELECTOR);
    const input = document.querySelector(INPUT_SELECTOR);
    const referralLink = input?.value?.trim();

    applyReferralCopy();
    ensureTutorial();
    applyVisitorState();
    enhanceRewardsSection();
    enhanceNativeControls();
    const dashboard = ensureReferralDashboard();
    enhanceReferredSection();
    ensureReferralHistoryPanel(dashboard);
    normalizeKnownPageCopy();

    if (!list || !referralLink || !/^https?:\/\//i.test(referralLink)) return;

    const alreadyEnhanced =
      list.dataset.vitamiiReferralLink === referralLink &&
      list.querySelectorAll("[data-vitamii-share]").length === 3;

    if (alreadyEnhanced) return;

    const message =
      `J’utilise Vitamii pour mon compagnon et j’en suis satisfait(e). ` +
      `Tu as 10 € offerts dès 49 € d’achat avec mon lien personnel :\n` +
      `${referralLink}\n\n` +
      `De mon côté, je recevrai aussi 10 € après ta première commande.`;

    const fragment = document.createDocumentFragment();
    fragment.append(
      makeShareLink({
        channel: "whatsapp",
        label: "WhatsApp",
        href: `https://wa.me/?text=${encodeURIComponent(message)}`,
        newTab: true,
      }),
      makeShareLink({
        channel: "sms",
        label: "SMS",
        href: `sms:?body=${encodeURIComponent(message)}`,
      }),
      makeShareLink({
        channel: "email",
        label: "E-mail",
        href:
          `mailto:?subject=${encodeURIComponent("10 € offerts chez Vitamii")}` +
          `&body=${encodeURIComponent(message)}`,
      }),
    );

    list.replaceChildren(fragment);
    list.dataset.vitamiiReferralLink = referralLink;
    updateReferralDashboard(dashboard);
  }

  let enhancementTimer = null;

  const observer = new MutationObserver(scheduleEnhancement);

  function scheduleEnhancement() {
    window.clearTimeout(enhancementTimer);
    enhancementTimer = window.setTimeout(() => {
      enhanceReferralPage();
    }, 160);
  }

  observer.observe(document.documentElement, { childList: true, subtree: true });
  scheduleEnhancement();
})();
